import React from 'react';
import {keyBy, get} from 'lodash';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import ReactGA from 'react-ga';
import PropTypes from 'prop-types';
import VideoCardThumb from './VideoCardThumb';
import VideoCardInfo from './VideoCardInfo';
import VideoCardActions from './VideoCardActions';

export default class VideoCard extends React.Component {
  static propTypes = {
    media: PropTypes.shape({
      mediaId: PropTypes.string.isRequired,
      clips: PropTypes.array.isRequired,
      vehicle: PropTypes.string.isRequired,
      driver: PropTypes.string,
      date: PropTypes.number.isRequired,
      address: PropTypes.string,
      status: PropTypes.string,
      driverId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      machineType: PropTypes.number,
      terminal: PropTypes.string,
      oer: PropTypes.string,
      triggerType: PropTypes.string.isRequired,
      terminalId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    }).isRequired,
    onVideoOpen: PropTypes.func.isRequired,
    onFlagVideo: PropTypes.func.isRequired,
    // See PNVI-5631
    addFilterChipOnDriverClick: PropTypes.func,
    addFilterChipOnVehicleClick: PropTypes.func,
    addFilterChipOnTerminalClick: PropTypes.func,
    addFilterOnOERClick: PropTypes.func,
    addOnDemandFilter: PropTypes.func,
    onDeleteVideo: PropTypes.func,
    index: PropTypes.number.isRequired,
    isMobile: PropTypes.bool,
    canDelete: PropTypes.bool,
    askDeleteConfirmation: PropTypes.bool,
    isInternal: PropTypes.bool,
    locale: PropTypes.string
  };

  static defaultProps = {
    locale: 'en',
    isMobile: false,
    canDelete: false,
    isInternal: false,
    askDeleteConfirmation: true,
    addOnDemandFilter: () => {},
    onDeleteVideo: () => {},
    addFilterOnOERClick: () => {},
    addFilterChipOnTerminalClick: () => {},
    addFilterChipOnVehicleClick: () => {},
    addFilterChipOnDriverClick: () => {}
  }

  getAvailableCameras = () => {
    const {media} = this.props;
    return keyBy(media.clips, it => it.channel);
  }

  handleClick = camera => {
    this.props.onVideoOpen(camera);

    ReactGA.event({
      category: 'Library',
      action: 'Open Player Page',
      label: 'Video Card'
    });
  }

  render() {
    const {
      media,
      addFilterChipOnDriverClick,
      addFilterChipOnVehicleClick,
      addFilterChipOnTerminalClick,
      addFilterOnOERClick,
      addOnDemandFilter,
      onDeleteVideo,
      askDeleteConfirmation
    } = this.props;

    if (media.clips.length > 1) {
      media.clips.sort((currentCamera, nextCamera) => currentCamera.channel - nextCamera.channel);
    }

    const thumb = get(media.clips, '[0].thumbURL', '');

    return (
      <div>
        <Card id={`videoCard-${media.mediaId}`} className="video__card">
          <CardMedia image={thumb} className="videomedia">
            <VideoCardThumb
              mediaId={media.mediaId}
              onClick={this.handleClick}
              source={thumb}
              machineType={media.machineType}
              availableCameras={this.getAvailableCameras()}
              isMobile={this.props.isMobile}
              locale={this.props.locale}
            />
          </CardMedia>
          <CardContent className="videoinfo__cont">
            <VideoCardInfo
              addFilterChipOnDriverClick={addFilterChipOnDriverClick}
              addFilterChipOnVehicleClick={addFilterChipOnVehicleClick}
              addFilterChipOnTerminalClick={addFilterChipOnTerminalClick}
              data={media}
              locale={this.props.locale}
            />
          </CardContent>
          <VideoCardActions
            media={media}
            index={this.props.index}
            addFilterOnOERClick={addFilterOnOERClick}
            addOnDemandFilter={addOnDemandFilter}
            onDeleteVideo={onDeleteVideo}
            askDeleteConfirmation={askDeleteConfirmation}
            canDelete={this.props.canDelete}
            isInternal={this.props.isInternal}
            onFlagVideo={this.props.onFlagVideo}
            locale={this.props.locale}
          />
        </Card>
      </div>
    );
  }
}
